import React, { useState } from 'react';
import HomePageBlock from '../components/homePageBlock';
import { Col, Row, Container, Button } from 'reactstrap';
import RandomChar from '../containers/randomChar';
import Layout from '../hoc/layout';
import Auxiliary from '../hoc/auxiliary';

const HomePage = () => {
  const [isShowRandomChar, setIsShowRandomChar] = useState(false)

  return (
    <>
      <HomePageBlock />
      <Layout />

      <Container>
        <Auxiliary>
          <Button
            color="primary"
            size='lg'
            onClick={() => setIsShowRandomChar(prevState => !prevState)}
          >
            Toggle Random Character
            </Button>

          <Row>
            <Col lg={{ size: 5, offset: 0 }}>
              {isShowRandomChar && <RandomChar />}
            </Col>
          </Row>
        </Auxiliary>
      </Container>
    </>
  )
}

export default HomePage